import React, { useContext } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { AccordionContext } from './AccordionWrapper';
import { styleBreakMobile, styleBreakDesktop } from '../layouts/Globals';
import { COLOR_GREY } from '../MaterialWatchman';

const useStyles = makeStyles(theme => ({
    accordion: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        cursor: 'pointer',
        lineHeight: '19px',
        [styleBreakMobile(theme)]: {
            padding: theme.spacing(1),
        },
        [styleBreakDesktop(theme)]: {
            padding: theme.spacing(2),
        },
    },
    accordionTitle: {
        fontWeight: 600,
        fontSize: theme.spacing(2) - 2,
        letterSpacing: '0.3px',
    },
    accordionContent: {
        fontWeight: 400,
        fontSize: theme.spacing(2) - 2,
        letterSpacing: '0.16px',
        [styleBreakMobile(theme)]: {
            padding: '0 8px 8px 8px',
        },
        [styleBreakDesktop(theme)]: {
            padding: '0 16px 16px 16px',
        },
    },
}));

const Accordion = props => {
    const classes = useStyles();
    const { isActive, setIsActive } = useContext(AccordionContext);

    const onExpandButtonClick = (e, index) => {
        e.preventDefault();
        setIsActive(index);
    };

    return (
        <Box borderBottom={`1px solid ${COLOR_GREY.light}`}>
            <Box className={classes.accordion} onClick={e => onExpandButtonClick(e, props.index)}>
                <Typography className={classes.accordionTitle}>{props.title}</Typography>
                <Box>{isActive === props.index ? <ExpandLess /> : <ExpandMore />}</Box>
            </Box>
            {isActive === props.index ? <Typography className={classes.accordionContent}>{props.description}</Typography> : null}
        </Box>
    );
};

export default Accordion;
